<template>
  <reg-inline-calendar-selector v-if="!readOnly && !field.readOnly"
                                ref="inputRef"
                                :required="maybeCall(field.required, value)"
                                :hint="field.hint"
                                :persistent-hint="true"
                                :disabled="field.disabled"
                                :label="label"
                                :date="fieldValue"
                                :text-input-class="field.class"
                                :rules="validationRules"
                                :prepend-icon="field.prependIcon"
                                :clearable="field.clearable"
                                :box="box || field.box"
                                @update:date="onDateChange" />
  <div v-else :class="{'reg-information': !small, 'reg-information-small': small}">
    <label>{{ field.label }}</label>
    <p v-if="field.hint" class="text-caption primary--text">
      {{ field.hint }}
    </p>
    <p>{{ fieldValue | formatUTCDate(field.dateFormat) }}</p>
  </div>
</template>

<script>
import { defineComponent, toRef } from 'vue'
import { useDynamicField } from '../composables/useDynamicField'
import InlineCalendarSelector from '~shared/selectors/InlineCalendarSelector.vue'

export default defineComponent({
  name: 'DynamicDateField',
  components: {
    'reg-inline-calendar-selector': InlineCalendarSelector
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit, expose }) {
    const {
      fieldValue,
      validationRules,
      label,
      inputRef,
      maybeCall,
      fieldChanged,
      hasError
    } = useDynamicField({
      value: toRef(props, 'value'),
      field: props.field,
      readOnly: props.readOnly,
      isValidating: toRef(props, 'isValidating'),
      itemKey: props.itemKey,
      emptyValue: null,
      emit
    })

    const onDateChange = (value) => {
      fieldValue.value = value
      fieldChanged(value)
    }

    // Expose properties for DynamicForm validation
    expose({
      hasError,
      validate: () => inputRef.value?.validate?.()
    })

    return {
      fieldValue,
      validationRules,
      label,
      inputRef,
      maybeCall,
      onDateChange
    }
  }
})
</script>

<style lang="scss">
</style>